import { IStringModelProps } from '../../models/StringModel/types'
import React, { useEffect } from 'react'
import { inputValidationCheck } from '../../../validators/inputValidators/inputValidators'
import { useFormValidation } from '../../../hooks/useFormValidation'
import { stringInputErrors } from '../../../utils/validationErrors/stringInputErrors'
import { buildControlsExt, stringInput } from '../../inputs/controls'
import {
    modifyActionParameter,
    setActionInvalid,
    setActionValid,
} from '../../../store/actions/actionsActions'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useDebouncedValue } from '../../../hooks/useDebouncedValue'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { selectInvalidActionByErrorKey } from '../../../store/selectors/actionsSelectors/invalidActionsSelectors'
import { getInputLabel } from '../utils/getInputLabel'
import { setDefaultValue } from '../utils/setDefault'
import { useInitialEffect } from '../../../hooks/useInitialEffect'
import { isEmpty } from '../utils/isEmpty'
import { useEffectAfterMount } from '../../../hooks/useEffectAfterMount'
import { PATH_JOINER } from '../../models/utils/getConfigBitPath'

export const StringACTN = (props: IStringModelProps) => {
    const { data = {}, dataSchema, name, wrapper, dataPath } = props
    const dispatch = useAppDispatch()

    const path = [...(dataPath.split(PATH_JOINER)), name]

    const {
        is_required: isRequired,
        name: inputLabel,
        type,
        description: tooltipText,
        is_email: isEmail,
        default: defaultValue,
    } = dataSchema

    const validationCheck = inputValidationCheck(type, dataSchema)
    const [
        inputState,
        setInputState,
        touched,
        setTouched,
        validationResult,
        isInputStateValid,
    ] = useFormValidation(data || {}, { [name]: validationCheck })

    const debouncedInputState = useDebouncedValue(inputState, 500)
    const isActionFieldInvalid = !!useAppSelector(
        selectInvalidActionByErrorKey(path)
    )
    const isDataEmpty = isEmpty(data, name)
    const errMsg = stringInputErrors(inputState?.[name], dataSchema)
    const label = getInputLabel(name, inputLabel)
    const className = !wrapper ? 'w-100' : ''

    const controlDescriptors = [
        stringInput({
            name,
            tooltipText,
            label,
            className,
            isColumn: true,
            errMsg,
            isRequired,
            isEmail,
            placeholder: defaultValue,
        }),
    ]

    const StringInput = buildControlsExt(
        controlDescriptors,
        inputState,
        setInputState,
        touched,
        setTouched,
        validationResult
    )

    useInitialEffect(() => {
        if (isDataEmpty) {
            if (defaultValue) {
                setDefaultValue(setInputState, name, defaultValue)
            } else {
                setInputState((prev: any) => ({ ...prev, [name]: null }))
            }
        }
    })

    useEffect(() => {
        dispatch(
            modifyActionParameter({
                path,
                data: inputState,
            })
        )
    }, [debouncedInputState, dispatch])

    useEffectAfterMount(() => {
        const isCurrentValueValid = isInputStateValid()
        if (isActionFieldInvalid === isCurrentValueValid) {
            if (isCurrentValueValid) {
                dispatch(setActionValid({ path }))
            } else {
                dispatch(setActionInvalid({ path }))
            }
        }
    }, [debouncedInputState])

    return <div className={`${!wrapper ? 'w-100' : ''}`}>{StringInput}</div>
}
